import { useRef, useEffect, useState } from "react";
import RightIcon from "../../assets/common/ic_right.svg?react";
import globalStore from "@/store/global.store";
export interface IOptions {
  id: string;
  label: string;
  disable?: boolean;
  show?: boolean;
}

interface ISelect {
  currId?: string;
  options: IOptions[];
  positioned?: (number | undefined)[]; // top right bottom left
  onChose: (value: IOptions) => void;
  onOutsideCb: () => void;
}

export function Select(prop: ISelect) {
  const positioned = prop.positioned ?? [0, 0, 0, 0];
  const height = 8 * prop.options.length + 4;
  const [selectId, setSelectId] = useState("");
  const latestSelectId = globalStore((state) => state.latestSelectId);

  const ref = useRef<HTMLDivElement>(null); //通过ref获取需要关闭的组件

  useEffect(() => {
    if (selectId && latestSelectId && selectId !== latestSelectId) {
      prop.onOutsideCb();
    }
  }, [latestSelectId, selectId]);

  useEffect(() => {
    const id = new Date().getTime().toString();
    globalStore.getState().setLatestSelectId(id);
    setSelectId(id);
    setTimeout(() => {
      document.addEventListener("click", handleClickOutside);
    }, 100);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event: MouseEvent) => {
    // 该组件存在 && 点击区域不是按钮区域 并且点击的区域不被包含在组件的区域内
    if (ref.current && !ref.current.contains(event.target as Node)) {
      prop.onOutsideCb();
    }
  };

  return (
    <div
      ref={ref}
      className={`absolute w-34 p-2 rd-1.5 shadow-[0_4px_16px_0_#191D2633] bg-white flex flex-col gap-1 h-${height} z-99`}
      style={{ top: positioned[0], right: positioned[1], bottom: positioned[2], left: positioned[3] }}
    >
      {prop.options.map((e) => {
        if (e.show === false) return null;
        return (
          <div
            className="w-full h-8 px-2 py-1.25 text-size-3.5 text-mx-secondary hover:bg-#191D260D rd-1.5 flex flex-items-center flex-justify-between"
            key={e.id}
            onClick={(event) => {
              event.stopPropagation();
              prop.onChose(e);
            }}
          >
            <span>{e.label}</span>
            {e.id == prop.currId && <RightIcon className="w-4 h-4" />}
          </div>
        );
      })}
    </div>
  );
}
